<template>
  <div id="app">
    <ThemeToggle />
    <Header />
    <router-view />
  </div>
</template>

<script>
import Header from "./components/Header";
import ThemeToggle from "./components/ThemeToggle";

export default {
  components: { Header, ThemeToggle }
};
</script>

<style>
@font-face {
  font-family: "OpticianSans";
  src: url(../src/assets/fonts/Optiker-K.woff2) format("woff2"),
    url(../src/assets/fonts/Optiker-K.ttf) format("truetype");
  font-style: normal;
  font-weight: normal;
  text-rendering: optimizeLegibility;
}

:root,
html[data-theme="dark"] {
  --bg: #000000;
  --text: #ffffff;
  --surface: #242424;
  --surface-2: #313131;
  --caption: #818181;
}

html[data-theme="light"] {
  --bg: #ffffff;
  --text: #000000;
  --surface: #f1f1f1;
  --surface-2: #e3e3e3;
  --caption: #6f6f6f;
}

* {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
}

body {
  background-color: var(--bg);
  padding: 0;
  margin: 0;
  transition: background-color 0.3s ease;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--bg);
  color: var(--text);
  margin: 0;
  height: 100vh;
  width: 100vw;
  transition: background-color 0.3s ease, color 0.3s ease;
}
</style>



// WEBPACK FOOTER //
// src/App.vue